export default __webpack_public_path__ + "static/media/music.882648ab.mp3";